import axios from "axios";
import router from "@/router";
import "@/plugins/elementUi.js";

export default {
  state: {
    bgList: [],
  },
  getters: {
    getbg(state) {
      return state.bgList;
    },
  },
  mutations: {
    getbgList(state, payload) {
      state.bgList = payload;
    },
  },
  actions: {
    getbgList(store, { token }) {
      const lsToken = JSON.parse(localStorage.getItem("token"));
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_BACKEND + "api/getlistbg",
          headers: {
            "Content-Type": "application/json",
            token: token || lsToken.token,
          },
        })
          .then(({ data, status }) => {
            if (status === 200) {
              store.commit("getbgList", data);
              resolve(true);
            }
          })
          .catch((error) => {
            element.$notify.error({
              title: `Token Broken!`,
              message: `Please Re-Login!`,
            });
            router.push("/Login");
            reject(error);
          });
      });
    },
    submitBg(store, payload) {
      return new Promise((resolve, reject) => {
        let form = new FormData();
        form.append("title", payload.title);
        form.append("subtitle", payload.subtitle);
        form.append("description", payload.description);
        form.append("desktop", payload.desktop);
        form.append("mobile", payload.mobile);

        axios({
          method: "post",
          url: process.env.VUE_APP_BACKEND + "api/uploadbg",
          data: form,
          headers: {
            "Content-Type": "multipart/form-data",
            token: payload.token,
          },
        })
          .then(({ data, status }) => {
            if (status == 200) {
              resolve(true);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    changeBg(store, payload) {
      return new Promise((resolve, reject) => {
        axios({
          method: "put",
          url: process.env.VUE_APP_BACKEND + "api/changebg",
          params: {
            backgroundId: payload.id,
          },
          headers: {
            "Content-Type": "application/json",
            token: payload.token,
          },
        })
          .then(({ data, status }) => {
            if (status == 200) {
              resolve(true);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    removeBg(store, payload) {
      return new Promise((resolve, reject) => {
        axios({
          method: "delete",
          url: process.env.VUE_APP_BACKEND + "api/removebg",
          params: {
            backgroundId: payload.id,
          },
          headers: {
            "Content-Type": "application/json",
            token: payload.token,
          },
        })
          .then(({ data, status }) => {
            if (status == 200) {
              resolve(true);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
